module.exports = new __parcel__URL__("shop_machines_discord_airdrop_trophy_v2.062b4c9e.png").toString();